// extracted by mini-css-extract-plugin
export var bottomWave = "K_cV";
export var container = "K_b";
export var footerText = "K_cc";
export var middleWave = "K_cT";
export var section = "K_d";
export var subtitle = "K_cj";
export var textContainer = "K_cW";
export var title = "K_h";